module.exports = __webpack_public_path__ + "static/media/34-3.a1cc85c8.mp3";